__turbopack_context__.v({
  "fullHeight": "n6xxaW_fullHeight",
  "mobileIframe": "n6xxaW_mobileIframe",
  "mobileIframeContainer": "n6xxaW_mobileIframeContainer",
});
